const STATUS_COLOR_ALIASES: Record<string, string> = {
  // Legacy org-status picker colours and the analytics palette equivalents.
  '#27ae7d': 'hsl(var(--status-success))',
  '#1ba74e': 'hsl(var(--status-success))',
  '#16a34a': 'hsl(var(--status-success))',
  '#22c55e': 'hsl(var(--status-success))',
  '#eb5757': 'hsl(var(--status-danger))',
  '#d52020': 'hsl(var(--status-danger))',
  '#ef5350': 'hsl(var(--status-danger))',
  '#ff6b6b': 'hsl(var(--status-danger))',
  '#eba000': 'hsl(var(--status-warning))',
  '#d28004': 'hsl(var(--status-warning))',
  '#dda51f': 'hsl(var(--status-warning))',
  '#f2b83b': 'hsl(var(--status-warning))',
  '#9b9faa': 'hsl(var(--status-neutral))',
  '#8996a9': 'hsl(var(--status-neutral))',
  '#718198': 'hsl(var(--status-neutral))',
  '#a4adbe': 'hsl(var(--status-neutral))',
}

// Status colours are stored as literal hex values by the organization settings API.
// Resolve the known palette to semantic tokens at render time so the analytics view
// follows the current light/dark theme without changing the saved customer setting.
export const resolveAgentStatusColor = (color: string) =>
  STATUS_COLOR_ALIASES[color.trim().toLowerCase()] ?? color
